<template>
  <sfs-form-modal
    :id="modalId"
    title="Duplicate Service"
    size="lg"
    @on-hide="resetFormData"
  >
    <services-form
      v-bind="value"
      @on-submit="createService"
      @on-save="redirectToService"
      @on-cancel="closeModal"
      :key="formKey"
    />
  </sfs-form-modal>
</template>

<script>
import ServicesForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'ServicesDuplicateModal',
  mixins: [formModalMixin],
  components: {
    ServicesForm,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      modalId: 'service-duplicate-modal',
    };
  },
  methods: {
    createService(data, handleCreate) {
      handleCreate(this.$servicesAPI.create(data));
    },
    redirectToService(service) {
      this.closeModal();
      this.$router.push({ name: 'service', params: { id: service.id } });
    },
  },
};
</script>
